export const firestoreCollections = {
  ADMIN_USER: 'adminUser',
  APP_USERS: 'appUsers',
  EVENTS: 'events',
  EVENT_LOCATIONS: 'experienceLocations',
  INVITED_CLIENTS: 'invitedClients',
  PAYMENT_LOG: 'paymentLog',
  REVENEW_SPLIT_LOG: 'revenewSplitConfig',
};

export const realtimeDBKey = {
  COUNTRY: 'locations/countries',
  STATE: 'locations/states',
  CITY: 'locations/cities',
};
